var _tspan, _tspan2, _tspan3, _tspan4, _tspan5, _tspan6, _tspan7, _tspan8, _tspan9, _tspan10, _tspan11, _tspan12, _tspan13, _tspan14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTkLegendA3En(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "a3",
    width: 1587.402,
    height: "297mm",
    viewBox: "0 0 1190.551 841.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    id: "rect2",
    d: "M0 0h1190.551v841.89H0z",
    style: {
      fill: "none",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "rand",
    transform: "translate(1.85 .207)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect1034",
    d: "M74.627 788.31h628.378c1.234 0 2.233 1.224 2.233 2.735v25.487c0 1.51-1 2.736-2.233 2.736H74.627Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("text", {
    id: "text503",
    x: 77.825,
    y: 814.526,
    style: {
      fontSize: 6,
      fontFamily: "SBBWeb-Roman,&quot"
    }
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan108479",
    x: 77.825,
    y: 814.526
  }, "Source: OpenStreetMap contributors \xA9 SBB/CFF/FFS www.tra\uFB01mage.ch www.geops.ch"))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    id: "text105827",
    x: 78.083,
    y: 798.215,
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontSize: 6,
      lineHeight: 1,
      fontFamily: "SBBWeb-Roman,&quot",
      InkscapeFontSpecification: "&quot",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal"
    }
  }, _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan104975",
    x: 78.083,
    y: 798.215
  }, "On certain bus routes, a supplement and/or seat reservation is required. Please also note that a bike space reservation is mandatory for bicycles on InterCity (IC) trains from 21 March to 31 October. Please note the information for the")), _tspan3 || (_tspan3 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan104977",
    x: 78.083,
    y: 804.215
  }, "desired connection in the (online) timetable. Depending on the zoom level, not all lines shown due to lack of space. All information without guarantee. Subject to change. The scope of application applies.")))), /*#__PURE__*/React.createElement("g", {
    id: "qr-code"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect23865",
    d: "M22.453 768.451h51.024v51.024H22.453Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path68822",
    d: "M23.91 769.91h1.3v1.3h-1.3Zm1.3 0h1.3v1.3h-1.3Zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.301v1.3h-1.3zm1.301 0h1.3v1.3h-1.3zm3.9 0h1.3v1.3h-1.3zm9.102 0h1.3v1.3h-1.3zm2.6 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.301v1.3h-1.3zm1.301 0h1.3v1.3h-1.3zm2.6 0h1.3v1.3h-1.3zm6.501 0h1.3v1.3h-1.3zm2.6 0h1.3v1.3h-1.3zm1.3 0h1.301v1.3h-1.3zm1.301 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.301v1.3h-1.3Zm-46.806 1.3h1.3v1.3h-1.3Zm7.801 0h1.3v1.3h-1.3zm2.6 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm2.601 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm2.6 0h1.3v1.3h-1.3zm1.3 0h1.301v1.3h-1.3zm1.301 0h1.3v1.3h-1.3zm2.6 0h1.3v1.3h-1.3zm3.901 0h1.3v1.3h-1.3zm5.2 0h1.3v1.3h-1.3zm1.3 0h1.301v1.3h-1.3zm1.301 0h1.3v1.3h-1.3zm3.9 0h1.3v1.3h-1.3zm7.802 0h1.3v1.3h-1.3Zm-46.807 1.3h1.3v1.3h-1.3Zm2.6 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm2.601 0h1.3v1.3h-1.3zm3.9 0h1.3v1.3h-1.3zm1.3 0h1.301v1.3h-1.3zm1.301 0h1.3v1.3h-1.3zm5.2 0h1.301v1.3h-1.3zm5.202 0h1.3v1.3h-1.3zm2.6 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm6.501 0h1.3v1.3h-1.3zm2.6 0h1.3v1.3h-1.3zm2.601 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm2.6 0h1.301v1.3h-1.3Zm-46.806 1.3h1.3v1.3h-1.3Zm2.6 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm2.601 0h1.3v1.3h-1.3zm2.6 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm2.601 0h1.3v1.3h-1.3zm2.6 0h1.3v1.3h-1.3Zm1.3 0h1.3v1.3h-1.3zm3.901 0h1.3v1.3h-1.3zm3.9 0h1.301v1.3h-1.3zm5.202 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm3.9 0h1.3v1.3h-1.3zm2.601 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm2.6 0h1.301v1.3h-1.3Zm-46.806 1.3h1.3v1.301h-1.3Zm2.6 0h1.3v1.301h-1.3zm1.3 0h1.3v1.301h-1.3zm1.3 0h1.3v1.301h-1.3zm2.601 0h1.3v1.301h-1.3zm5.2 0h1.301v1.301h-1.3zm2.601 0h1.3v1.301h-1.3zm1.3 0h1.3v1.301h-1.3Zm3.901 0h1.3v1.301h-1.3zm3.9 0h1.3v1.301h-1.3zm1.3 0h1.301v1.301h-1.3zm3.901 0h1.3v1.301h-1.3zm6.501 0h1.3v1.301h-1.3zm2.6 0h1.3v1.301h-1.3zm2.601 0h1.3v1.301h-1.3zm1.3 0h1.3v1.301h-1.3zm1.3 0h1.3v1.301h-1.3zm2.6 0h1.301v1.301h-1.3Zm-46.806 1.3h1.3v1.301h-1.3Zm7.801 0h1.3v1.301h-1.3zm2.6 0h1.3v1.301h-1.3zm2.6 0h1.301v1.301h-1.3zm6.502 0h1.3v1.301h-1.3zm2.6 0h1.3v1.301h-1.3zm5.201 0h1.3v1.301h-1.3zm1.3 0h1.3v1.301h-1.3zm5.2 0h1.301v1.301h-1.3zm1.301 0h1.3v1.301h-1.3zm1.3 0h1.3v1.301h-1.3zm2.6 0h1.3v1.301h-1.3zm7.802 0h1.3v1.301h-1.3Zm-46.807 1.301h1.3v1.3h-1.3Zm1.3 0h1.3v1.3h-1.3Zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.301v1.3h-1.3zm1.301 0h1.3v1.3h-1.3zm2.6 0h1.3v1.3h-1.3zm2.6 0h1.301v1.3h-1.3zm2.601 0h1.3v1.3h-1.3zm2.6 0h1.3v1.3h-1.3zm2.601 0h1.3v1.3h-1.3zm2.6 0h1.3v1.3h-1.3zm2.6 0h1.301v1.3h-1.3zm2.601 0h1.3v1.3h-1.3zm2.6 0h1.3v1.3h-1.3zm2.6 0h1.301v1.3h-1.3zm2.601 0h1.3v1.3h-1.3zm2.6 0h1.3v1.3h-1.3zm1.3 0h1.301v1.3h-1.3zm1.301 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.301v1.3h-1.3zm-31.204 1.3h1.3v1.3h-1.3zm2.6 0h1.3v1.3h-1.3zm1.3 0h1.301v1.3h-1.3zm1.301 0h1.3v1.3h-1.3zm2.6 0h1.3v1.3h-1.3zm2.6 0h1.301v1.3h-1.3zm1.301 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm3.9 0h1.301v1.3h-1.3zm2.601 0h1.3v1.3h-1.3Zm-36.405 1.3h1.3v1.3h-1.3Zm1.3 0h1.3v1.3h-1.3Zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm2.601 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.301v1.3h-1.3zm2.601 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3Zm1.3 0h1.3v1.3h-1.3zm3.901 0h1.3v1.3h-1.3zm3.9 0h1.301v1.3h-1.3zm2.601 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.301v1.3h-1.3zm3.901 0h1.3v1.3h-1.3zm2.6 0h1.301v1.3h-1.3zm2.601 0h1.3v1.3h-1.3zm2.6 0h1.3v1.3h-1.3zm-45.506 1.3h1.3v1.3h-1.3Zm1.3 0h1.3v1.3h-1.3Zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm2.6 0h1.301v1.3h-1.3zm11.703 0h1.3v1.3h-1.3zm2.6 0h1.3v1.3h-1.3zm2.6 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.301v1.3h-1.3zm1.301 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm2.6 0h1.301v1.3h-1.3zm2.601 0h1.3v1.3h-1.3zm6.501 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm-41.605 1.3h1.3v1.301h-1.3zm2.6 0h1.3v1.301h-1.3zm1.3 0h1.3v1.301h-1.3zm2.6 0h1.3v1.301h-1.3zm1.3 0h1.3v1.301h-1.3zm1.3 0h1.301v1.301h-1.3zm1.301 0h1.3v1.301h-1.3zm1.3 0h1.3v1.301h-1.3zm2.6 0h1.3v1.301h-1.3zm1.3 0h1.301v1.301h-1.3zm1.301 0h1.3v1.301h-1.3zm5.2 0h1.301v1.301h-1.3zm1.301 0h1.3v1.301h-1.3zm1.3 0h1.3v1.301h-1.3zm3.9 0h1.3v1.301h-1.3zm2.601 0h1.3v1.301h-1.3zm1.3 0h1.3v1.301h-1.3zm1.3 0h1.3v1.301h-1.3zm5.201 0h1.3v1.301h-1.3zm1.3 0h1.3v1.301h-1.3zm2.6 0h1.301v1.301h-1.3Zm-46.806 1.301h1.3v1.3h-1.3Zm1.3 0h1.3v1.3h-1.3Zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.301v1.3h-1.3zm2.601 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm2.6 0h1.301v1.3h-1.3zm1.301 0h1.3v1.3h-1.3zm5.2 0h1.301v1.3h-1.3zm6.502 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm2.6 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm3.901 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm3.901 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm2.6 0h1.3v1.3h-1.3zm-45.506 1.3h1.3v1.3h-1.3Zm3.9 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.301v1.3h-1.3zm1.301 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm3.9 0h1.301v1.3h-1.3zm1.301 0h1.3v1.3h-1.3zm2.6 0h1.3v1.3h-1.3Zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.301v1.3h-1.3zm2.601 0h1.3v1.3h-1.3zm2.6 0h1.3v1.3h-1.3zm3.901 0h1.3v1.3h-1.3zm3.9 0h1.3v1.3h-1.3zm1.3 0h1.301v1.3h-1.3zm3.901 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm2.601 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm2.6 0h1.301v1.3h-1.3zm-45.506 1.3h1.3v1.3h-1.3Zm1.3 0h1.3v1.3h-1.3zm2.6 0h1.3v1.3h-1.3zm6.502 0h1.3v1.3h-1.3zm3.9 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3Zm1.3 0h1.3v1.3h-1.3zm2.601 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm2.601 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm3.9 0h1.301v1.3h-1.3zm6.502 0h1.3v1.3h-1.3zm3.9 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm-37.705 1.3h1.3v1.3h-1.3zm5.2 0h1.301v1.3h-1.3zm6.502 0h1.3v1.3h-1.3zm6.5 0h1.301v1.3h-1.3zm5.202 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm2.6 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.301v1.3h-1.3zm1.301 0h1.3v1.3h-1.3zm2.6 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.301v1.3h-1.3zm-45.506 1.3h1.3v1.301h-1.3Zm1.3 0h1.3v1.301h-1.3zm3.9 0h1.301v1.301h-1.3zm2.601 0h1.3v1.301h-1.3zm1.3 0h1.3v1.301h-1.3zm2.6 0h1.301v1.301h-1.3zm2.601 0h1.3v1.301h-1.3zm2.6 0h1.3v1.301h-1.3zm2.601 0h1.3v1.301h-1.3zm2.6 0h1.3v1.301h-1.3zm3.901 0h1.3v1.301h-1.3zm6.5 0h1.301v1.301h-1.3zm3.901 0h1.3v1.301h-1.3zm1.3 0h1.3v1.301h-1.3zm3.901 0h1.3v1.301h-1.3zm3.9 0h1.301v1.301h-1.3zm-45.506 1.301h1.3v1.3h-1.3Zm1.3 0h1.3v1.3h-1.3zm2.6 0h1.3v1.3h-1.3zm2.601 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm3.9 0h1.301v1.3h-1.3zm2.601 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3Zm2.6 0h1.301v1.3h-1.3zm1.301 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm6.501 0h1.3v1.3h-1.3zm2.6 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm2.601 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm2.601 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm2.6 0h1.301v1.3h-1.3Zm-46.806 1.3h1.3v1.3h-1.3Zm1.3 0h1.3v1.3h-1.3Zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm2.6 0h1.301v1.3h-1.3zm2.601 0h1.3v1.3h-1.3zm2.6 0h1.3v1.3h-1.3zm1.3 0h1.301v1.3h-1.3zm3.901 0h1.3v1.3h-1.3Zm3.901 0h1.3v1.3h-1.3zm2.6 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.301v1.3h-1.3zm1.301 0h1.3v1.3h-1.3zm2.6 0h1.3v1.3h-1.3zm2.6 0h1.3v1.3h-1.3zm3.901 0h1.3v1.3h-1.3zm3.9 0h1.301v1.3h-1.3zm3.901 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm-45.506 1.3h1.3v1.3h-1.3Zm1.3 0h1.3v1.3h-1.3Zm3.9 0h1.3v1.3h-1.3zm1.3 0h1.301v1.3h-1.3zm1.301 0h1.3v1.3h-1.3zm3.9 0h1.3v1.3h-1.3zm2.601 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3Zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.301v1.3h-1.3zm1.301 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm2.6 0h1.301v1.3h-1.3zm1.301 0h1.3v1.3h-1.3zm3.9 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.301v1.3h-1.3zm1.301 0h1.3v1.3h-1.3zm2.6 0h1.3v1.3h-1.3zm3.901 0h1.3v1.3h-1.3zm2.6 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.301v1.3h-1.3Zm-46.806 1.3h1.3v1.3h-1.3Zm1.3 0h1.3v1.3h-1.3Zm1.3 0h1.3v1.3h-1.3zm6.501 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.301v1.3h-1.3zm1.301 0h1.3v1.3h-1.3zm5.2 0h1.301v1.3h-1.3zm1.301 0h1.3v1.3h-1.3zm3.9 0h1.3v1.3h-1.3zm1.3 0h1.301v1.3h-1.3zm1.301 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm2.6 0h1.301v1.3h-1.3zm1.301 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm3.9 0h1.301v1.3h-1.3zm1.301 0h1.3v1.3h-1.3zm5.2 0h1.301v1.3h-1.3zm-41.605 1.3h1.3v1.301h-1.3zm2.6 0h1.3v1.301h-1.3zm3.9 0h1.3v1.301h-1.3zm1.3 0h1.301v1.301h-1.3zm1.301 0h1.3v1.301h-1.3zm2.6 0h1.3v1.301h-1.3Zm1.3 0h1.3v1.301h-1.3zm3.901 0h1.3v1.301h-1.3zm6.501 0h1.3v1.301h-1.3zm3.9 0h1.3v1.301h-1.3zm1.3 0h1.301v1.301h-1.3zm1.301 0h1.3v1.301h-1.3zm1.3 0h1.3v1.301h-1.3zm2.6 0h1.3v1.301h-1.3zm2.601 0h1.3v1.301h-1.3zm2.6 0h1.3v1.301h-1.3zm1.3 0h1.3v1.301h-1.3zm1.3 0h1.301v1.301h-1.3zm-44.206 1.301h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm3.901 0h1.3v1.3h-1.3zm2.6 0h1.3v1.3h-1.3zm3.901 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3Zm6.501 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.301v1.3h-1.3zm1.301 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm3.9 0h1.301v1.3h-1.3zm2.601 0h1.3v1.3h-1.3zm9.102 0h1.3v1.3h-1.3zm-45.507 1.3h1.3v1.3h-1.3Zm1.3 0h1.3v1.3h-1.3Zm2.6 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm2.601 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm2.6 0h1.3v1.3h-1.3zm7.802 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm2.6 0h1.3v1.3h-1.3zm2.6 0h1.301v1.3h-1.3zm2.601 0h1.3v1.3h-1.3zm5.2 0h1.301v1.3h-1.3zm1.301 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm3.901 0h1.3v1.3h-1.3zm2.6 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.301v1.3h-1.3zm-45.506 1.3h1.3v1.3h-1.3Zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm2.6 0h1.301v1.3h-1.3zm2.601 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.301v1.3h-1.3zm2.601 0h1.3v1.3h-1.3zm3.9 0h1.301v1.3h-1.3zm5.202 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm3.9 0h1.3v1.3h-1.3zm3.901 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm9.102 0h1.3v1.3h-1.3Zm-46.807 1.3h1.3v1.3h-1.3Zm1.3 0h1.3v1.3h-1.3Zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.301v1.3h-1.3zm1.301 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm3.901 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3Zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.301v1.3h-1.3zm2.601 0h1.3v1.3h-1.3zm2.6 0h1.3v1.3h-1.3zm3.901 0h1.3v1.3h-1.3zm2.6 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.301v1.3h-1.3zm1.301 0h1.3v1.3h-1.3zm2.6 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm2.601 0h1.3v1.3h-1.3zm2.6 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.301v1.3h-1.3Zm-46.806 1.3h1.3v1.3h-1.3Zm1.3 0h1.3v1.3h-1.3Zm2.6 0h1.3v1.3h-1.3zm2.6 0h1.301v1.3h-1.3zm5.202 0h1.3v1.3h-1.3zm6.5 0h1.3v1.3h-1.3zm2.601 0h1.3v1.3h-1.3zm3.9 0h1.3v1.3h-1.3zm2.601 0h1.3v1.3h-1.3zm2.6 0h1.3v1.3h-1.3zm3.9 0h1.301v1.3h-1.3zm2.601 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm2.6 0h1.301v1.3h-1.3zm5.202 0h1.3v1.3h-1.3zm-45.507 1.3h1.3v1.301h-1.3Zm2.6 0h1.3v1.301h-1.3zm2.6 0h1.3v1.301h-1.3zm1.3 0h1.301v1.301h-1.3zm1.301 0h1.3v1.301h-1.3zm2.6 0h1.3v1.301h-1.3zm1.3 0h1.3v1.301h-1.3zm2.601 0h1.3v1.301h-1.3zm1.3 0h1.3v1.301h-1.3zm2.6 0h1.3v1.301h-1.3zm1.3 0h1.301v1.301h-1.3zm1.301 0h1.3v1.301h-1.3zm1.3 0h1.3v1.301h-1.3zm1.3 0h1.3v1.301h-1.3zm3.901 0h1.3v1.301h-1.3zm1.3 0h1.3v1.301h-1.3zm3.9 0h1.3v1.301h-1.3zm2.601 0h1.3v1.301h-1.3zm1.3 0h1.3v1.301h-1.3zm1.3 0h1.3v1.301h-1.3zm1.3 0h1.3v1.301h-1.3zm2.601 0h1.3v1.301h-1.3zm2.6 0h1.3v1.301h-1.3zm1.3 0h1.3v1.301h-1.3zm1.3 0h1.301v1.301h-1.3Zm-46.806 1.301h1.3v1.3h-1.3Zm2.6 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm2.6 0h1.301v1.3h-1.3zm2.601 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm3.901 0h1.3v1.3h-1.3zm5.2 0h1.301v1.3h-1.3zm1.301 0h1.3v1.3h-1.3zm2.6 0h1.3v1.3h-1.3zm2.6 0h1.301v1.3h-1.3zm1.301 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm7.802 0h1.3v1.3h-1.3zm7.8 0h1.301v1.3h-1.3Zm-46.806 1.3h1.3v1.3h-1.3Zm2.6 0h1.3v1.3h-1.3zm2.6 0h1.3v1.3h-1.3zm1.3 0h1.301v1.3h-1.3zm1.301 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm2.6 0h1.3v1.3h-1.3zm2.601 0h1.3v1.3h-1.3zm2.6 0h1.3v1.3h-1.3Zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.301v1.3h-1.3zm2.601 0h1.3v1.3h-1.3zm6.501 0h1.3v1.3h-1.3zm2.6 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.301v1.3h-1.3zm2.601 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.301v1.3h-1.3zm1.301 0h1.3v1.3h-1.3zm2.6 0h1.3v1.3h-1.3zm-33.804 1.3h1.3v1.3h-1.3zm5.2 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3Zm3.901 0h1.3v1.3h-1.3zm2.6 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.301v1.3h-1.3zm3.901 0h1.3v1.3h-1.3zm5.201 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm5.201 0h1.3v1.3h-1.3Zm-41.606 1.3h1.3v1.3h-1.3Zm1.3 0h1.3v1.3h-1.3Zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.301v1.3h-1.3zm1.301 0h1.3v1.3h-1.3zm2.6 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.301v1.3h-1.3zm5.202 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm7.801 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm2.6 0h1.3v1.3h-1.3zm5.201 0h1.3v1.3h-1.3zm2.6 0h1.3v1.3h-1.3zm2.601 0h1.3v1.3h-1.3zm2.6 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.301v1.3h-1.3Zm-46.806 1.3h1.3v1.301h-1.3Zm7.801 0h1.3v1.301h-1.3zm3.9 0h1.3v1.301h-1.3zm1.3 0h1.301v1.301h-1.3zm2.601 0h1.3v1.301h-1.3zm2.6 0h1.3v1.301h-1.3zm5.201 0h1.3v1.301h-1.3zm1.3 0h1.3v1.301h-1.3zm2.601 0h1.3v1.301h-1.3zm6.5 0h1.301v1.301h-1.3zm2.601 0h1.3v1.301h-1.3zm5.201 0h1.3v1.301h-1.3zm1.3 0h1.3v1.301h-1.3zm2.6 0h1.3v1.301h-1.3zm-45.506 1.301h1.3v1.3h-1.3Zm2.6 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm2.601 0h1.3v1.3h-1.3zm2.6 0h1.3v1.3h-1.3zm5.201 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3Zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.301v1.3h-1.3zm1.301 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm2.6 0h1.301v1.3h-1.3zm2.601 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.301v1.3h-1.3zm1.301 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.301v1.3h-1.3zm1.301 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm-45.506 1.3h1.3v1.3h-1.3Zm2.6 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm2.601 0h1.3v1.3h-1.3zm2.6 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm5.201 0h1.3v1.3h-1.3Zm3.901 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.301v1.3h-1.3zm1.301 0h1.3v1.3h-1.3zm2.6 0h1.3v1.3h-1.3zm3.9 0h1.301v1.3h-1.3zm2.601 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm2.601 0h1.3v1.3h-1.3zm2.6 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.301v1.3h-1.3Zm-46.806 1.3h1.3v1.3h-1.3Zm2.6 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm2.601 0h1.3v1.3h-1.3zm2.6 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.301v1.3h-1.3zm1.301 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm2.6 0h1.3v1.3h-1.3zm1.3 0h1.301v1.3h-1.3zm1.301 0h1.3v1.3h-1.3zm5.2 0h1.301v1.3h-1.3zm6.502 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm5.2 0h1.301v1.3h-1.3zm2.601 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.301v1.3h-1.3Zm-46.806 1.3h1.3v1.3h-1.3Zm7.801 0h1.3v1.3h-1.3zm2.6 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm2.601 0h1.3v1.3h-1.3zm5.2 0h1.301v1.3h-1.3zm7.802 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm6.501 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm3.9 0h1.301v1.3h-1.3zm1.301 0h1.3v1.3h-1.3zm5.2 0h1.301v1.3h-1.3Zm-46.806 1.3h1.3v1.301h-1.3Zm1.3 0h1.3v1.301h-1.3Zm1.3 0h1.3v1.301h-1.3zm1.3 0h1.3v1.301h-1.3zm1.3 0h1.3v1.301h-1.3zm1.3 0h1.301v1.301h-1.3zm1.301 0h1.3v1.301h-1.3zm2.6 0h1.3v1.301h-1.3zm2.6 0h1.301v1.301h-1.3zm1.301 0h1.3v1.301h-1.3zm1.3 0h1.3v1.301h-1.3zm3.9 0h1.301v1.301h-1.3zm2.601 0h1.3v1.301h-1.3zm6.501 0h1.3v1.301h-1.3zm2.6 0h1.3v1.301h-1.3zm1.3 0h1.3v1.301h-1.3zm1.3 0h1.301v1.301h-1.3zm3.901 0h1.3v1.301h-1.3zm1.3 0h1.3v1.301h-1.3zm5.201 0h1.3v1.301h-1.3zm1.3 0h1.3v1.301h-1.3zm1.3 0h1.301v1.301h-1.3z",
    style: {
      fill: "#000",
      strokeWidth: 0.216698
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "sbb"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect22814",
    d: "M971.83 22.677h196.044v22.94H971.83z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect397399",
    d: "M973.281 23.927h192.107v20.659H973.281z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2879",
    d: "M973.28 44.374h60.703V24.139h-60.702v20.235Z",
    style: {
      fill: "#e42328",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2881",
    d: "M1009.012 32.708h6.564v-5.196h3.091v5.196h6.563l-5.28-5.196h3.918l6.745 6.745-6.745 6.744h-3.92l5.28-5.196h-6.56v5.196h-3.093v-5.196h-6.563l5.28 5.196h-3.916l-6.744-6.744 6.744-6.745h3.917",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2883",
    d: "M1040.247 36.972c-.039 3.492 2.896 5.04 6.03 5.04 3.848 0 5.891-1.944 5.891-4.543 0-3.212-3.173-3.867-4.205-4.123-3.55-.913-4.224-1.052-4.224-2.142 0-1.19 1.15-1.606 2.143-1.606 1.488 0 2.698.435 2.796 2.143h3.015c0-3.273-2.717-4.561-5.672-4.561-2.559 0-5.296 1.388-5.296 4.285 0 2.658 2.122 3.471 4.226 4.026 2.082.554 4.203.813 4.203 2.339 0 1.448-1.666 1.766-2.757 1.766-1.666 0-3.133-.735-3.133-2.62",
    style: {
      fill: "#221e20",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2885",
    d: "M1057.203 29.933h2.915c1.11 0 2.143.277 2.143 1.626 0 1.19-.814 1.686-1.904 1.686h-3.154v-3.312Zm-3.113 11.741h6.861c2.559 0 5-1.23 5-4.106 0-1.764-.875-3.094-2.6-3.59a3.106 3.106 0 0 0 1.926-2.956c0-2.637-1.826-3.51-4.524-3.51h-6.663v14.162Zm3.113-6.307h3.39c1.329 0 2.241.576 2.241 2.023 0 1.467-1.07 1.865-2.3 1.865h-3.33",
    style: {
      fill: "#221e20",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2887",
    d: "M1071.14 29.933h2.916c1.11 0 2.142.277 2.142 1.626 0 1.19-.813 1.686-1.904 1.686h-3.154v-3.312Zm-3.113 11.741h6.861c2.56 0 4.998-1.23 4.998-4.106 0-1.764-.872-3.094-2.598-3.59a3.106 3.106 0 0 0 1.924-2.956c0-2.637-1.824-3.51-4.522-3.51h-6.663v14.162Zm3.115-6.307h3.39c1.33 0 2.242.576 2.242 2.023 0 1.467-1.07 1.865-2.3 1.865h-3.331",
    style: {
      fill: "#221e20",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2889",
    d: "M1099.666 32.272c-.377-3.272-2.994-5.096-6.108-5.096-4.384 0-6.96 3.273-6.96 7.477 0 4.086 2.576 7.358 6.96 7.358 3.471 0 5.91-2.26 6.227-5.792h-3.016c-.237 1.865-1.308 3.173-3.211 3.173-2.796 0-3.849-2.38-3.849-4.74 0-2.479 1.053-4.86 3.849-4.86 1.546 0 2.896 1.071 3.094 2.479",
    style: {
      fill: "#221e20",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2891",
    d: "M1101.702 41.674h3.114v-5.851h5.93v-2.42h-5.93v-3.272h6.842v-2.617h-9.956",
    style: {
      fill: "#221e20",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2893",
    d: "M1113.551 41.674h3.105v-5.851h5.924v-2.42h-5.926v-3.272h6.835v-2.617h-9.938",
    style: {
      fill: "#221e20",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2895",
    d: "M1130.233 41.674h3.122v-5.851h5.924v-2.42h-5.924v-3.272h6.834v-2.617h-9.955",
    style: {
      fill: "#221e20",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2897",
    d: "M1142.457 41.674h3.104v-5.851h5.924v-2.42h-5.924v-3.272h6.852v-2.617h-9.957",
    style: {
      fill: "#221e20",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2899",
    d: "M1153.554 36.972c-.035 3.492 2.89 5.04 6.031 5.04 3.854 0 5.889-1.944 5.889-4.543 0-3.212-3.177-3.867-4.194-4.123-3.55-.913-4.228-1.052-4.228-2.142 0-1.19 1.141-1.606 2.142-1.606 1.48 0 2.695.435 2.801 2.143h2.998c0-3.273-2.712-4.561-5.656-4.561-2.57 0-5.3 1.388-5.3 4.285 0 2.658 2.124 3.471 4.23 4.026 2.07.554 4.193.813 4.193 2.339 0 1.448-1.66 1.766-2.748 1.766-1.678 0-3.14-.735-3.14-2.62",
    style: {
      fill: "#221e20",
      strokeWidth: 0
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "title"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path523",
    d: "M-.224 24.25h451.336c1.087 0 1.963.785 1.963 1.755v55.981c0 .968-.876 1.755-1.96 1.755H-.224Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("text", {
    id: "text745",
    x: 22.102,
    y: 48.444,
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontSize: 18,
      fontFamily: "SBBWeb-Light,&quot",
      InkscapeFontSpecification: "&quot",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      isolation: "isolate"
    }
  }, _tspan4 || (_tspan4 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan977",
    x: 22.102,
    y: 48.444
  }, "Saver Day Pass / Special Day Pass / Municipal Saver")), _tspan5 || (_tspan5 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan979",
    x: 22.102,
    y: 70.944
  }, "Day Pass without a valid Half Fare Travelcard")))), /*#__PURE__*/React.createElement("g", {
    id: "legend",
    transform: "translate(0 -27)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect426128-0-8-3-9-2",
    width: 196.237,
    height: 119.749,
    x: 15.117,
    y: 117.193,
    rx: 2.551,
    ry: 2.33,
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "scaleline",
    transform: "translate(0 -12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect2491",
    d: "M22.815 226.519h135.509v13.898H22.815Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "text2343",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("text", {
    id: "text756",
    style: {
      fontSize: 7,
      fontFamily: "SBBWeb-Roman,&quot",
      isolation: "isolate"
    },
    transform: "translate(88.55 236.294)"
  }, _tspan6 || (_tspan6 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan750",
    x: 0,
    y: 0
  }, "50")), /*#__PURE__*/React.createElement("tspan", {
    id: "tspan752",
    x: 9.731,
    y: 0,
    style: {
      letterSpacing: ".00342em"
    }
  }, "k"), _tspan7 || (_tspan7 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan754",
    x: 13.388,
    y: 0
  }, "m")))), /*#__PURE__*/React.createElement("path", {
    id: "path1881",
    d: "M175.435 226.52v13.371l-152.168.074V226.52",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: ".9031px",
      strokeMiterlimit: 3
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g777"
  }, /*#__PURE__*/React.createElement("text", {
    id: "text763",
    x: 22.21,
    y: 154.043,
    style: {
      fontSize: 7,
      fontFamily: "SBBWeb-Roman,&quot",
      isolation: "isolate"
    }
  }, _tspan8 || (_tspan8 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan761",
    x: 22.21,
    y: 154.043
  }, "Railways"))), /*#__PURE__*/React.createElement("g", {
    id: "g775"
  }, /*#__PURE__*/React.createElement("path", {
    id: "line765",
    d: "M23.628 142.724h32.28",
    style: {
      fill: "none",
      stroke: "#eb0000",
      strokeWidth: "1.41732px",
      strokeLinecap: "square",
      strokeMiterlimit: 3
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g795"
  }, /*#__PURE__*/React.createElement("text", {
    id: "text781",
    x: 121.817,
    y: 154.127,
    style: {
      fontSize: 7,
      fontFamily: "SBBWeb-Roman,&quot",
      isolation: "isolate"
    }
  }, _tspan9 || (_tspan9 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan779",
    x: 121.817,
    y: 154.127
  }, "Cableways"))), /*#__PURE__*/React.createElement("g", {
    id: "g793"
  }, /*#__PURE__*/React.createElement("path", {
    id: "line783",
    d: "M122.891 142.724h32.279",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: "1.41732px",
      strokeLinecap: "square",
      strokeMiterlimit: 3
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g838",
    transform: "translate(-49.63 -9)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "text402292-9-5-9-7-1",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("text", {
    id: "text809",
    style: {
      fontSize: 7,
      fontFamily: "SBBWeb-Roman,&quot",
      isolation: "isolate"
    },
    transform: "translate(171.621 196.83)"
  }, _tspan10 || (_tspan10 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan95027",
    x: 0,
    y: 0
  }, "Ask for")), _tspan11 || (_tspan11 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan95029",
    x: 0,
    y: 8.75
  }, "validity on")), _tspan12 || (_tspan12 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan95031",
    x: 0,
    y: 17.5
  }, "site")))), /*#__PURE__*/React.createElement("g", {
    id: "g836"
  }, /*#__PURE__*/React.createElement("path", {
    id: "line830",
    d: "M172.523 185.415v0",
    style: {
      fill: "none",
      stroke: "#999",
      strokeWidth: "1.41732px",
      strokeLinecap: "round",
      strokeMiterlimit: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "line832",
    d: "M175.457 185.415h27.878",
    style: {
      fill: "none",
      stroke: "#999",
      strokeWidth: "1.41732px",
      strokeLinecap: "round",
      strokeMiterlimit: 3,
      strokeDasharray: "0,0,0,2.93449"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "line834",
    d: "M204.802 185.415v0",
    style: {
      fill: "none",
      stroke: "#999",
      strokeWidth: "1.41732px",
      strokeLinecap: "round",
      strokeMiterlimit: 3
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g866"
  }, /*#__PURE__*/React.createElement("text", {
    id: "text852",
    x: 171.621,
    y: 154.042,
    style: {
      fontSize: 7,
      fontFamily: "SBBWeb-Roman,&quot",
      isolation: "isolate"
    }
  }, "Boats"), /*#__PURE__*/React.createElement("g", {
    id: "g864"
  }, /*#__PURE__*/React.createElement("path", {
    id: "line854",
    d: "M172.523 142.724h32.279",
    style: {
      fill: "none",
      stroke: "#2a6698",
      strokeWidth: "1.41732px",
      strokeLinecap: "square",
      strokeMiterlimit: 3
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g904"
  }, /*#__PURE__*/React.createElement("text", {
    id: "text880",
    x: 72.072,
    y: 154.042,
    style: {
      fontSize: 7,
      fontFamily: "SBBWeb-Roman,&quot",
      isolation: "isolate"
    }
  }, "Buses"), /*#__PURE__*/React.createElement("g", {
    id: "g902"
  }, /*#__PURE__*/React.createElement("path", {
    id: "line882",
    d: "M73.547 142.724h31.707",
    style: {
      fill: "none",
      stroke: "#3b3b3b",
      strokeWidth: "1.98425px",
      strokeLinecap: "square",
      strokeMiterlimit: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "line892",
    d: "M73.26 142.724h32.279",
    style: {
      fill: "none",
      stroke: "#fbd700",
      strokeWidth: "1.41732px",
      strokeLinecap: "square",
      strokeMiterlimit: 3
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g937",
    transform: "translate(0 -9)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "text402292-9-5-9",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("text", {
    id: "text920",
    style: {
      fontSize: 7,
      fontFamily: "SBBWeb-Roman,&quot",
      isolation: "isolate"
    },
    transform: "translate(22.21 196.83)"
  }, "Free travel")), /*#__PURE__*/React.createElement("g", {
    id: "g935"
  }, /*#__PURE__*/React.createElement("path", {
    id: "line923",
    d: "M23.485 172.15h32.279",
    style: {
      fill: "none",
      stroke: "#eb0000",
      strokeWidth: "1.41732px",
      strokeLinecap: "square",
      strokeMiterlimit: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "line925",
    d: "M23.485 180.994h32.279",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: "1.41732px",
      strokeLinecap: "square",
      strokeMiterlimit: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "line927",
    d: "M23.486 185.415h32.279",
    style: {
      fill: "none",
      stroke: "#2a6698",
      strokeWidth: "1.41732px",
      strokeLinecap: "square",
      strokeMiterlimit: 3
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g933"
  }, /*#__PURE__*/React.createElement("path", {
    id: "line929",
    d: "M23.772 176.572h31.707",
    style: {
      fill: "none",
      stroke: "#3b3b3b",
      strokeWidth: "1.98425px",
      strokeLinecap: "square",
      strokeMiterlimit: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "line931",
    d: "M23.485 176.572h32.279",
    style: {
      fill: "none",
      stroke: "#fbd700",
      strokeWidth: "1.41732px",
      strokeLinecap: "square",
      strokeMiterlimit: 3
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g1048",
    transform: "translate(-49.63 -9)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "text402292-9-5-9-7",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("text", {
    id: "text1043",
    style: {
      fontSize: 7,
      fontFamily: "SBBWeb-Roman,&quot",
      isolation: "isolate"
    },
    transform: "translate(121.818 196.83)"
  }, "No reduction")), /*#__PURE__*/React.createElement("path", {
    id: "line1046",
    d: "M122.891 185.415h32.28",
    style: {
      fill: "none",
      stroke: "#999",
      strokeWidth: "1.41732px",
      strokeLinecap: "square",
      strokeMiterlimit: 3
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "state-publisher"
  }, /*#__PURE__*/React.createElement("g", {
    id: "text2350",
    style: {
      isolation: "isolate"
    },
    transform: "translate(9)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "text1052",
    style: {
      fontSize: 7,
      fontFamily: "SBBWeb-Roman,&quot",
      isolation: "isolate"
    },
    transform: "translate(51.046 128.648)"
  }, _tspan13 || (_tspan13 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan1050",
    x: 0,
    y: 0
  }, "***publishedAt***")))), /*#__PURE__*/React.createElement("g", {
    id: "text2347",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("text", {
    id: "text1057",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontSize: 7,
      fontFamily: "SBBWeb-Roman,&quot",
      InkscapeFontSpecification: "&quot",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      isolation: "isolate"
    },
    transform: "translate(22.21 128.648)"
  }, _tspan14 || (_tspan14 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan69015",
    x: 0,
    y: 0
  }, "Created on")))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTkLegendA3En);
export default __webpack_public_path__ + "static/media/tk_legend_a3_en.01c9f10dd1e9b87e35605cb301bd8207.svg";
export { ForwardRef as ReactComponent };